import HttpService from "../services/Http.Service";

async function getSensor(data) {
    return await HttpService.controlServerWithToken("GET", "sensor", "get_sensor", data);
}

async function createSensor(data) {
    return await HttpService.controlServerWithToken("POST", "sensor", "create_sensor", data);
}

async function updateSensor(data) {
    return await HttpService.controlServerWithToken("POST", "sensor", "update_sensor", data);
}

async function updateSensorStatus(data) {
    return await HttpService.controlServerWithToken("POST", "sensor", "update_sensor_status", data);
}

async function setAllSensorStatus(data) {
    return await HttpService.controlServerWithToken("POST", "sensor", "set_all_sensor_status", data);
}

async function deleteSensor(data) {
    return await HttpService.controlServerWithToken("POST", "sensor", "delete_sensor", data);
}

export { getSensor, createSensor, updateSensor, updateSensorStatus, setAllSensorStatus, deleteSensor };
